import { cycleCountIdFormat } from "@redotech/redo-inventory-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const uploadCycleCountCsv = unaryRpc({
  name: "uploadCycleCountCsv" as const,
  input: z.object({ id: cycleCountIdFormat.schema }),
  output: z.object({ appliedCount: z.number().int().nonnegative() }),
});
